var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',[_c('router-view')],1),_c('datAlert'),_c('datSnackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }